import type { Folder } from "~/types/folder"
import type { PageData } from "~/types/pages"

export async function useMarketingPage<T extends { locationId: number }>(
  selector: (items: Array<Folder | PageData>) => T[],
  lookup?: MaybeRefOrGetter<Record<string, number> | undefined>,
) {
  const route = useRoute<"om-path" | "artikler-path" | "studentliv-path">()

  const { data, suspense } = useMarketing(selector)

  await suspense()

  return computed(() => {
    const locationId = toValue(lookup)?.[route.params.path] || Number(route.query.side)
    return data.value?.find(p => p.locationId === locationId)
  })

  // TODO: Consider throwing 404 here if the page does not exist?
}
